export default __webpack_public_path__ + "static/media/incontext-cover.aa679956.png";